import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/image/icon/more.png'
import _imports_1 from '@/assets/image/icon/hot1.png'
import _imports_2 from '@/assets/image/icon/hot2.png'
import _imports_3 from '@/assets/image/icon/hot3.png'
import _imports_4 from '@/assets/image/icon/hot-up.png'
import _imports_5 from '@/assets/image/hot/day-bg.png'
import _imports_6 from '@/assets/image/hot/days-icon.png'
import _imports_7 from '@/assets/image/icon/nice.png'
import _imports_8 from '@/assets/image/icon/comment.png'


const _withScopeId = n => (_pushScopeId("data-v-7d5164f0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "header-tabs" }
const _hoisted_2 = { class: "follow" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = {
  key: 0,
  class: "check-img"
}
const _hoisted_5 = { name: "follow-user__name" }
const _hoisted_6 = {
  key: 0,
  class: "follow-more"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { name: "follow-user__name" }, "更多关注", -1))
const _hoisted_9 = [
  _hoisted_7,
  _hoisted_8
]
const _hoisted_10 = {
  key: 2,
  class: "hot-list"
}
const _hoisted_11 = { class: "item-time" }
const _hoisted_12 = {
  key: 0,
  class: "item-hot-img",
  src: _imports_1
}
const _hoisted_13 = {
  key: 1,
  class: "item-hot-img",
  src: _imports_2
}
const _hoisted_14 = {
  key: 2,
  class: "item-hot-img",
  src: _imports_3
}
const _hoisted_15 = {
  key: 3,
  class: "item-hot-num"
}
const _hoisted_16 = ["onClick"]
const _hoisted_17 = { class: "item-content__title" }
const _hoisted_18 = { class: "item-content-footer" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_4 }, null, -1))
const _hoisted_20 = {
  key: 3,
  class: "morning"
}
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "morning-banner",
  src: _imports_5
}, null, -1))
const _hoisted_22 = { class: "morning-list-days" }
const _hoisted_23 = { class: "days" }
const _hoisted_24 = { class: "days-month" }
const _hoisted_25 = { class: "days-day" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "icon" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_6 })
], -1))
const _hoisted_27 = { class: "article" }
const _hoisted_28 = ["onClick"]
const _hoisted_29 = { class: "article-top__title" }
const _hoisted_30 = { class: "article-bottom" }
const _hoisted_31 = { class: "user" }
const _hoisted_32 = { class: "user-name" }
const _hoisted_33 = { class: "options" }
const _hoisted_34 = { class: "options-left" }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_7 }, null, -1))
const _hoisted_36 = { class: "options-right" }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_8 }, null, -1))

import { ref, reactive, onMounted } from 'vue'
import { List, Tabs, Tab, Swipe, SwipeItem } from 'vant'
import { useRouter, useRoute } from 'vue-router'
import MArticle from '@/views/components/MArticle/MArticle.vue'
import MImage from '@/components/MImage/MImage.vue'
import FooterTips from '@/views/components/FooterTips/FooterTips.vue'
import {
  getInformationTypsList,
  getFollowInformationList,
  getZcjH5InformationHotList,
  getZcjH5InformationList,
} from '@/api/hots'
import { getHomeBanner } from '@/api/home'
import { getUserFollowList } from '@/api/user'
import { HOT_TABS } from '@/constant'


export default /*#__PURE__*/_defineComponent({
  __name: 'MessageList',
  props: {
  searchValue: String,
},
  setup(__props, { expose }) {

const props = __props;


const router = useRouter()
const route = useRoute()

const tabsActive = ref(1001)
const state = reactive({
  loading: false,
  finished: false,
  hotTabs: HOT_TABS,
  pagination: {
    pageNum: 1,
    pageSize: 10,
  },
  informationList: [],
  userFollowList: [],
  hotList: [],
  currentTab: 1001,
  banner: [],
  publisherId: null,
})

onMounted(async () => {
  await fetchUserFollowList()
  fetchInformationTypsList()
  fetchHomeBanner()
  fetchList()
})

// 获取Tabs栏目
const fetchInformationTypsList = async () => {
  const { dataList } = await getInformationTypsList({
    pageNum: 1,
    pageSize: 20,
  })
  state.hotTabs = [
    ...state.hotTabs,
    ...dataList.map((item) => ({
      ...item,
      type: item.id,
      title: item.informationType,
    })),
  ]
}
const fetchHomeBanner = async () => {
  const { dataList = [] } = await getHomeBanner({ advertisementType: 3 })
  state.banner = dataList
}
// 获取我关注的用户
const fetchUserFollowList = async () => {
  const res = await getUserFollowList({ pageNum: 1, pageSize: 10 })
  state.userFollowList = res.data.list.map((item) => ({
    ...item,
    isCheck: false,
  }))
  // state.userFollowList = []
  if (state.userFollowList.length) {
    // state.hotTabs = state.hotTabs.filter((item) => item.title != '关注')
    if (state.hotTabs.findIndex((item) => item.title === '关注') === -1) {
      state.hotTabs = [{ title: '关注', type: 1000 }, ...state.hotTabs]
    }
  }
}
// 获取我关注的
const fetchFollowInformationList = async () => {
  console.log('fetchFollowInformationList==》')
  const res = await getFollowInformationList({
    ...state.pagination,
    informationTitle: props.searchValue,
    publisherId: state.publisherId || '',
  })
  state.informationList = [...state.informationList, ...res.data.list]
  state.pagination.pageNum++
  state.finished = res.data.isLastPage
  state.loading = false
}
// 获取热榜
const fetchInformationHotList = async () => {
  const res = await getZcjH5InformationHotList({
    ...state.pagination,
    informationTitle: props.searchValue,
  })
  state.hotList = [...state.hotList, ...res.data.list]
  state.pagination.pageNum++
  state.loading = false
  state.finished = res.data.isLastPage
}
// 获取列表
const fetchInformationList = async (params) => {
  const res = await getZcjH5InformationList({
    ...state.pagination,
    ...params,
    informationTitle: props.searchValue,
  })
  state.informationList = [
    ...state.informationList,
    ...res.data.list.map((item) => ({
      ...item,
      month: item.pushDate
        ? item.pushDate.split(' ')[0].split('-')[1]
        : item.createDate.split(' ')[0].split('-')[1],
      day: item.pushDate
        ? item.pushDate.split(' ')[0].split('-')[2]
        : item.createDate.split(' ')[0].split('-')[2],
    })),
  ]
  state.pagination.pageNum++
  state.loading = false
  state.finished = res.data.isLastPage
}
const fetchList = (test) => {
  console.log('fetchList==>')
  if (tabsActive.value === 1000) {
    fetchFollowInformationList()
  } else if (tabsActive.value === 1001) {
    fetchInformationList()
  } else if (tabsActive.value === 1002) {
    fetchInformationHotList()
  } else if (tabsActive.value === 1003) {
    fetchInformationList({ types: 0 })
  } else {
    fetchInformationList({
      types: tabsActive.value,
    })
  }
}
const handleSearch = () => {
  resetFetchParams()
  fetchList()
}
const handleCancel = () => {
  handleSearch()
}
const handleTabsChange = (key) => {
  resetFetchParams()
  tabsActive.value = key
  switch (key) {
    case 1000:
      fetchUserFollowList()
      fetchList()
      break
    default:
      fetchList()
      break
  }
}
const handleRouterToDetail = (item) => {
  router.push({
    path: `/talk-detail/${item.id}`,
    query: { detailType: 1, refresh: true },
  })
}
const handleRouterToHotDetail = (item, index) => {
  router.push({
    path: `/talk-detail/${item.id}`,
    query: {
      detailType: 1,
      hotIndex: index,
      refresh: true,
      calorific: item.calorificValue,
    },
  })
}
const resetFetchParams = () => {
  state.pagination.pageNum = 1
  state.informationList = []
  state.hotList = []
  state.publisherId = null
  // state.loading = false
  // state.finished = false
}
const handleFetchMyFollow = (user) => {
  state.userFollowList = state.userFollowList.map((item) => {
    if (user.staffId === item.staffId) {
      item.isCheck = !item.isCheck
      if (item.isCheck === true) {
        state.publisherId = item.staffId
      } else {
        state.publisherId = null
      }
    } else {
      item.isCheck = false
    }
    return item
  })
  state.pagination.pageNum = 1
  state.informationList = []
  state.hotList = []
  // resetFetchParams()
  fetchFollowInformationList()
}
const handleBannerLinkTo = (linkUrl) => {
  location.href = linkUrl
}

expose({
  handleSearch,
  handleCancel,
})

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_unref(Tabs), {
        active: tabsActive.value,
        "onUpdate:active": _cache[0] || (_cache[0] = ($event: any) => ((tabsActive).value = $event)),
        swipeable: "",
        onChange: handleTabsChange
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(state.hotTabs, (item) => {
            return (_openBlock(), _createBlock(_unref(Tab), {
              title: item.title,
              key: item.title,
              name: item.type
            }, null, 8, ["title", "name"]))
          }), 128))
        ]),
        _: 1
      }, 8, ["active"])
    ]),
    (tabsActive.value === 1000 && state.userFollowList.length > 0)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createElementVNode("div", _hoisted_2, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(state.userFollowList, (item, index) => {
              return (_openBlock(), _createElementBlock(_Fragment, {
                key: item.id
              }, [
                (index < 5)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      class: "follow-user",
                      onClick: ($event: any) => (handleFetchMyFollow(item))
                    }, [
                      _createElementVNode("div", {
                        class: _normalizeClass(["user-avatar", { 'avatar-active': item.isCheck }])
                      }, [
                        _createVNode(MImage, {
                          class: _normalizeClass({ 'avatar-img-active': item.isCheck }),
                          type: "avatar",
                          src: item.headImg
                        }, null, 8, ["class", "src"]),
                        (item.isCheck)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_4))
                          : _createCommentVNode("", true)
                      ], 2),
                      _createElementVNode("div", _hoisted_5, _toDisplayString(item.nickName), 1)
                    ], 8, _hoisted_3))
                  : _createCommentVNode("", true)
              ], 64))
            }), 128)),
            _createVNode(_component_router_link, { to: "/my-follow" }, {
              default: _withCtx(() => [
                (state.userFollowList.length > 5)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_6, _hoisted_9))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ]),
          _createVNode(_unref(List), {
            loading: state.loading,
            "onUpdate:loading": _cache[1] || (_cache[1] = ($event: any) => ((state.loading) = $event)),
            finished: state.finished,
            "immediate-check": false,
            onLoad: fetchList
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(state.informationList, (item) => {
                return (_openBlock(), _createBlock(MArticle, {
                  key: item.id,
                  article: item,
                  onHandleClick: handleRouterToDetail
                }, null, 8, ["article"]))
              }), 128))
            ]),
            _: 1
          }, 8, ["loading", "finished"]),
          (state.finished)
            ? (_openBlock(), _createBlock(FooterTips, { key: 0 }))
            : _createCommentVNode("", true)
        ], 64))
      : _createCommentVNode("", true),
    (tabsActive.value === 1001)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _createVNode(_unref(Swipe), {
            class: "hot-banner",
            autoplay: 5000
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(state.banner, (item) => {
                return (_openBlock(), _createBlock(_unref(SwipeItem), {
                  key: item.imgUrl
                }, {
                  default: _withCtx(() => [
                    _createVNode(MImage, {
                      src: item.imgUrl,
                      "data-src": item.imgUrl,
                      onClick: ($event: any) => (handleBannerLinkTo(item.linkUrl))
                    }, null, 8, ["src", "data-src", "onClick"])
                  ]),
                  _: 2
                }, 1024))
              }), 128))
            ]),
            _: 1
          }),
          _createVNode(_unref(List), {
            loading: state.loading,
            "onUpdate:loading": _cache[2] || (_cache[2] = ($event: any) => ((state.loading) = $event)),
            finished: state.finished,
            "immediate-check": false,
            onLoad: fetchList
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(state.informationList, (item) => {
                return (_openBlock(), _createBlock(MArticle, {
                  key: item.id,
                  article: item,
                  onHandleClick: handleRouterToDetail
                }, null, 8, ["article"]))
              }), 128))
            ]),
            _: 1
          }, 8, ["loading", "finished"]),
          (state.finished)
            ? (_openBlock(), _createBlock(FooterTips, { key: 0 }))
            : _createCommentVNode("", true)
        ], 64))
      : _createCommentVNode("", true),
    (tabsActive.value === 1002)
      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
          _createVNode(_unref(List), {
            loading: state.loading,
            "onUpdate:loading": _cache[3] || (_cache[3] = ($event: any) => ((state.loading) = $event)),
            finished: state.finished,
            "immediate-check": false,
            onLoad: fetchList
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(state.hotList, (item, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: item.id,
                  class: "item"
                }, [
                  _createElementVNode("div", _hoisted_11, " 发布于 · " + _toDisplayString(item?.createDate.split(' ')[0]), 1),
                  (index === 0)
                    ? (_openBlock(), _createElementBlock("img", _hoisted_12))
                    : (index === 1)
                      ? (_openBlock(), _createElementBlock("img", _hoisted_13))
                      : (index === 2)
                        ? (_openBlock(), _createElementBlock("img", _hoisted_14))
                        : (_openBlock(), _createElementBlock("div", _hoisted_15, _toDisplayString(index + 1 < 10 ? `0${index + 1}` : index + 1), 1)),
                  _createElementVNode("div", {
                    class: "item-content",
                    onClick: ($event: any) => (handleRouterToHotDetail(item, index + 1))
                  }, [
                    _createElementVNode("div", _hoisted_17, _toDisplayString(item.informationTitle), 1),
                    _createElementVNode("div", _hoisted_18, [
                      _createElementVNode("div", {
                        class: _normalizeClass({
                'item-content-footer__count': true,
                top1: index === 0,
                top2: index === 1,
                top3: index === 2,
              })
                      }, _toDisplayString(item.calorificValue), 3),
                      _hoisted_19
                    ])
                  ], 8, _hoisted_16)
                ]))
              }), 128))
            ]),
            _: 1
          }, 8, ["loading", "finished"]),
          (state.finished)
            ? (_openBlock(), _createBlock(FooterTips, { key: 0 }))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (tabsActive.value === 1003)
      ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
          _hoisted_21,
          _createVNode(_unref(List), {
            loading: state.loading,
            "onUpdate:loading": _cache[4] || (_cache[4] = ($event: any) => ((state.loading) = $event)),
            finished: state.finished,
            "immediate-check": false,
            onLoad: fetchList
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(state.informationList, (item) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: item.id,
                  class: "morning-list"
                }, [
                  _createElementVNode("div", _hoisted_22, [
                    _createElementVNode("div", _hoisted_23, [
                      _createElementVNode("div", _hoisted_24, _toDisplayString(item.month), 1),
                      _createElementVNode("div", _hoisted_25, _toDisplayString(item.day), 1)
                    ]),
                    _hoisted_26
                  ]),
                  _createElementVNode("div", _hoisted_27, [
                    _createElementVNode("div", {
                      class: "article-top",
                      onClick: ($event: any) => (handleRouterToDetail(item))
                    }, [
                      _createElementVNode("div", _hoisted_29, _toDisplayString(item.informationTitle), 1),
                      _createVNode(MImage, {
                        src: item.coverMapUrl
                      }, null, 8, ["src"])
                    ], 8, _hoisted_28),
                    _createElementVNode("div", _hoisted_30, [
                      _createElementVNode("div", _hoisted_31, [
                        _createVNode(MImage, {
                          type: "avatar",
                          class: "user-avt",
                          src: item.headImg
                        }, null, 8, ["src"]),
                        _createElementVNode("div", _hoisted_32, _toDisplayString(item.userName), 1)
                      ]),
                      _createElementVNode("div", _hoisted_33, [
                        _createElementVNode("div", _hoisted_34, [
                          _hoisted_35,
                          _createElementVNode("span", null, _toDisplayString(item.likeCount), 1)
                        ]),
                        _createElementVNode("div", _hoisted_36, [
                          _hoisted_37,
                          _createElementVNode("span", null, _toDisplayString(item.commentCount), 1)
                        ])
                      ])
                    ])
                  ])
                ]))
              }), 128))
            ]),
            _: 1
          }, 8, ["loading", "finished"]),
          (state.finished)
            ? (_openBlock(), _createBlock(FooterTips, { key: 0 }))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (
      tabsActive.value !== 1000 &&
      tabsActive.value !== 1001 &&
      tabsActive.value !== 1002 &&
      tabsActive.value !== 1003
    )
      ? (_openBlock(), _createBlock(_unref(List), {
          key: 4,
          loading: state.loading,
          "onUpdate:loading": _cache[5] || (_cache[5] = ($event: any) => ((state.loading) = $event)),
          finished: state.finished,
          "immediate-check": false,
          onLoad: fetchList
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(state.informationList, (item) => {
              return (_openBlock(), _createBlock(MArticle, {
                key: item.id,
                article: item,
                onHandleClick: handleRouterToDetail
              }, null, 8, ["article"]))
            }), 128)),
            (state.finished)
              ? (_openBlock(), _createBlock(FooterTips, { key: 0 }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["loading", "finished"]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})